module.exports = __webpack_public_path__ + "img/downhill_line3.b8685a19.svg";